<template>
  <div>
    <div class="bg-white py-3 py-sm-0">
      <b-row class="no-gutters px-3 px-sm-0">
        <b-col>
          <b-table
            responsive
            class="text-center table-list mb-0"
            striped
            :fields="fields"
            :items="items"
            :busy="isBusy"
            show-empty
            empty-text="ไม่พบข้อมูล"
          >
            <template v-slot:cell(imageUrl)="data">
              <div class="position-relative">
                <div
                  class="square-box b-contain"
                  v-bind:style="{
                    'background-image': 'url(' + data.item.imageUrl + ')',
                  }"
                ></div>
              </div>
            </template>
            <template v-slot:cell(productName)="data">
              <p class="mb-1 nobreak two-lines text-left">
                {{ data.item.productName ? data.item.productName : "-" }}
              </p>
              <p class="f-size-14 text-gray1 mb-0 text-left">
                SKU : {{ data.item.productSKU ? data.item.productSKU : "-" }}
              </p>
              <p class="f-size-14 text-gray1 mb-0 text-left">
                Collection:
                {{ data.item.collection ? data.item.collection : "-" }}
              </p>
            </template>

            <template v-slot:cell(totalStock)="data">
              <p class="m-0">{{ data.item.totalStock | numeral("0,0") }}</p>
              <p
                class="
                  mt-4
                  d-flex
                  justify-content-center
                  f-size-14
                  text-purple1
                "
              >
                <u
                  class="pointer pr-2"
                  :id="'btnAdjustAddStock' + data.item.productId"
                  @click="onAdjustStock(1, data.item)"
                  >เพิ่ม</u
                >
                <u
                  class="pointer pr-2"
                  :id="'btnAdjustReduceStock' + data.item.productId"
                  @click="onAdjustStock(2, data.item)"
                  >ลด</u
                >
                <u
                  class="pointer pr-2"
                  :id="'btnAdjustStock' + data.item.productId"
                  @click="onAdjustStock(3, data.item)"
                  >ปรับ</u
                >
              </p>
            </template>

            <template v-slot:cell(onlineStock)="data">
              <p class="m-0">
                {{ data.item.onlineStock | numeral("0,0") }} /
                {{ data.item.offlineStock | numeral("0,0") }}
              </p>
            </template>

            <template v-slot:cell(reserve)="data">
              <p class="m-0">{{ data.item.reserve | numeral("0,0") }}</p>
            </template>

            <template v-slot:table-busy>
              <div class="text-center text-black my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong class="ml-2">Loading...</strong>
              </div>
            </template>
          </b-table>
        </b-col>
      </b-row>
      <b-row class="no-gutters px-3 px-sm-0" v-if="!isBusy">
        <b-col
          class="form-inline justify-content-center justify-content-sm-end"
        >
          <div class="d-sm-flex m-3">
            <b-pagination
              v-model="filter.page"
              :total-rows="rows"
              :per-page="filter.pageSize"
              class="m-md-0 page-item"
              @change="pagination"
              align="center"
            ></b-pagination>
          </div>

          <b-form-select
            class="mr-sm-3 select-page"
            v-model="filter.pageSize"
            @change="hanndleChangePageSize"
            :options="pageOptions"
          ></b-form-select>
        </b-col>
      </b-row>
    </div>
    <ModalInventory
      ref="modalInventory"
      :actionType="inventoryActionType"
      :productSectectedId="productSectectedId"
      :productSectectedStock="productSectectedStock"
      v-on:onRefreshProductList="onRefreshProductList"
    />
  </div>
</template>

<script>
import ModalInventory from "../inventory-all/ModalInventory.vue";
export default {
  components: {
    ModalInventory,
  },
  data() {
    return {
      called: false,
      fields: [
        {
          key: "imageUrl",
          label: `ภาพสินค้า`,
          class: "w-100px text-nowrap",
        },
        {
          key: "productName",
          label: `ชื่อสินค้า/SKU`,
          class: "w-400px text-nowrap",
        },
        {
          key: "totalStock",
          label: `คลังรวม`,
          class: "w-100px text-nowrap",
        },
        {
          key: "onlineStock",
          label: `Online / Offline`,
          class: "w-100px text-nowrap",
        },
        {
          key: "reserve",
          label: `Reserve`,
          class: "w-50px text-nowrap",
        },
      ],
      items: [],
      activeItem: "",
      isBusy: false,
      filter: {
        search: "",
        productInventoryTypes: [],
        productStatus: [],
        categories: [0, 0, 0, 0],
        stockStatus: [3],
        collections: "",
        StartDate: "",
        EndDate: "",
        pageSize: 10,
        page: 1,
      },
      rows: 0,
      pageOptions: [
        { value: 10, text: "10 / หน้า" },
        { value: 30, text: "30 / หน้า" },
        { value: 50, text: "50 / หน้า" },
        { value: 100, text: "100 / หน้า" },
      ],
      inventoryActionType: 1,
      productSectectedId: -1,
      productSectectedStock: 0,
    };
  },
  async created() {
    await this.getFilter();
    this.$emit("updateFilter", this.filter)
    this.getProductList(this.filter);
  },
  methods: {
    getFilter() {
      if (this.$route.query.search) {
        this.filter.search = this.$route.query.search;
      }
      if (this.$route.query.productInventoryTypes) {
        this.filter.productInventoryTypes = this.$route.query.productInventoryTypes.split(",").map(Number);
      }
      if (this.$route.query.productStatus) {
        this.filter.productStatus = this.$route.query.productStatus.split(",").map(Number);
      }
      if (this.$route.query.categories) {
        this.filter.categories = this.$route.query.categories.split(",").map(Number);
      }
      if (this.$route.query.stockStatus) {
        this.filter.stockStatus = this.$route.query.stockStatus.split(",").map(Number);
      }
      if (this.$route.query.StartDate) {
        this.filter.StartDate = this.$route.query.StartDate;
      }
      if (this.$route.query.EndDate) {
        this.filter.EndDate = this.$route.query.EndDate;
      }
      if (this.$route.query.page) {
        this.filter.page = parseInt(this.$route.query.page) || 1;
      }
      if (this.$route.query.pageSize) {
        this.filter.pageSize = parseInt(this.$route.query.pageSize) || 10;
      }
      if (this.$route.query.collections) {
        this.filter.collections = this.$route.query.collections;
      }
    },
    setFilter(newFilter) {
      let filter = this.filter;
      if(newFilter) filter = newFilter;
      this.$router
        .push({
          path: "/inventory",
          query: {
            brandID: this.$route.query.brandID,
            search: filter.search,
            productInventoryTypes: filter.productInventoryTypes.toString(),
            productStatus: filter.productStatus.toString(),
            categories: filter.categories.toString(),
            stockStatus: filter.stockStatus.toString(),
            StartDate: filter.StartDate || "",
            EndDate: filter.EndDate || "",
            pageSize: filter.pageSize,
            page: filter.page,
            collections: filter.collections,
            tab: this.$route.query.tab || 1
          },
        })
        .catch((err) => {});
    },
    onSubmitFilter(filter) {
      this.setFilter();
      this.getProductList(filter);
    },
    onRefreshProductList() {
      let filter = this.filter;
      this.setFilter();
      this.getProductList(filter);
    },
    onAdjustStock(adjustFlag, productSectected) {
      this.inventoryActionType = adjustFlag;
      this.productSectectedId = productSectected.productId;
      this.productSectectedStock = productSectected.totalStock;
      this.$nextTick(() => {
        this.$refs.modalInventory.show();
      });
    },
    pagination(Page) {
      this.filter.page = Page;
      this.setFilter();
      this.getProductList(this.filter);
    },
    isActive: function(menuItem) {
      return this.activeItem == menuItem;
    },
    onSubmitFilterPanel(filter){
      this.setFilter(filter);
      this.getProductList(filter);
    },
    getProductList(filter) {
      this.isBusy = true;
      if (filter) {
        // ถ้าไม่ได้ส่ง filter มาจะพัง
        this.filter.collections = filter.collections;
        this.filter.productInventoryTypes = filter.productInventoryTypes;
        this.filter.productStatus = filter.productStatus;
        this.filter.search = filter.search;
        this.filter.stockStatus = filter.stockStatus;
        this.filter.categories = filter.categories;
        this.filter.page = filter.page;
        this.filter.StartDate = filter.StartDate;
        this.filter.EndDate = filter.EndDate;
      }

      this.axios
        .post(`${this.$baseUrl}/productinventory`, this.filter)
        .then((data) => {
          this.rows = data.totalCount;
          this.addFields(data.data.branch);
          this.items = data.data.product;
          this.items.forEach((product) => {
            product.branch.forEach((branch) => {
              product[branch.branchId] = branch.stock
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            });
          });
          this.isBusy = false;
        });
    },
    addFields(branch) {
      if (!this.called) {
        branch.forEach((e) => {
          this.fields.push({
            key: e.branchId.toString(),
            label: e.branchName,
            class: "w-50px text-nowrap",
          });
        });
        this.called = true;
      }
    },
    hanndleChangePageSize(value) {
      this.filter.page = 1;
      this.filter.pageSize = value;
      this.setFilter();
      this.getProductList();
    },
  },
};
</script>

<style scoped></style>
